import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConnectivityService } from '@quorum/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sha-connectivity-banner',
  templateUrl: './connectivity-banner.component.html',
  styleUrls: ['./connectivity-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectivityBannerComponent {
  readonly isOffline$: Observable<boolean>;

  constructor(connectivity: ConnectivityService) {
    this.isOffline$ = connectivity.isOnline$.pipe(map((online) => !online));
  }
}
